import { api } from "./useApi";

// Clube Conectado — conteúdo educacional em vídeo dentro do painel.
export const ClubeApi = () => ({
  getVitrine: async () => {
    const response = await api.post("/clube/select-vitrine");
    return response.data;
  },
  getTrilha: async (idTrilha: number) => {
    const response = await api.post("/clube/select-trilha", {
      id_trilha: idTrilha,
    });
    return response.data;
  },
  getAula: async (idAula: number) => {
    const response = await api.post("/clube/select-aula", { id_aula: idAula });
    return response.data;
  },
  salvarProgresso: async (idAula: number, porcentagem: number) => {
    const response = await api.post("/clube/salvar-progresso", {
      id_aula: idAula,
      porcentagem,
    });
    return response.data;
  },
  // registra evento de engajamento (acesso/abertura) para as métricas
  registrarEvento: (
    tipo: "acesso_vitrine" | "ver_trilha" | "abrir_aula" | "abrir_material",
    idReferencia?: number
  ) => {
    api
      .post("/clube/registrar-evento", { tipo, id_referencia: idReferencia })
      .catch(() => {});
  },
});
